import { render, staticRenderFns } from "./DepartmentDiscount.vue?vue&type=template&id=687a6d6f"
import script from "./DepartmentDiscount.vue?vue&type=script&lang=js"
export * from "./DepartmentDiscount.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDiscount.vue?vue&type=style&index=0&id=687a6d6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports